import { useCallback, useEffect } from 'react';
import { incrementAutosaveSavingBeforeUnloadMetric } from '../../metrics/autosaveMetrics';

export const useAutosaveWindowEvents = (getHasInFlightSaves: () => boolean) => {
  const handleBeforeUnload = useCallback(
    (e: BeforeUnloadEvent) => {
      if (getHasInFlightSaves()) {
        incrementAutosaveSavingBeforeUnloadMetric();
        e.preventDefault();
        e.returnValue = true;
      }
    },
    [getHasInFlightSaves]
  );

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [handleBeforeUnload]);
};
